'use strict';
module.exports = function(data, encoding){
    return new Buffer(data, encoding);   
};
module.exports.test = function(b){
    return Buffer.isBuffer(b);
};


//////////////////
// WEBPACK FOOTER
// C:/Users/Pablo/source/repos/prote/angular/~/xlsx-style/~/jszip/lib/nodeBuffer.js
// module id = ../../../../xlsx-style/node_modules/jszip/lib/nodeBuffer.js
// module chunks = 19